import Tooltip from "rc-tooltip";
import React from "react";
import { Button, Icon } from "semantic-ui-react";
import { UUID } from "../../../../apis/types/dataLayerTypes";
import styles from "./styles.module.css";

interface FieldActionsProps {
	fieldId: UUID;
	isAssociated: boolean;
	existingAssociation: boolean;
	isVisible: boolean;
	onVisiblePlotsChange: (fieldId: UUID, visible: boolean) => void;
	onAssociateChange: (fieldId: UUID, associated: boolean) => Promise<void> | void;
}

const FieldActions = ({
	fieldId,
	isAssociated,
	existingAssociation,
	isVisible,
	onVisiblePlotsChange,
	onAssociateChange,
}: FieldActionsProps) => {
	const tooltipMouseEnterDelay = 0.5;
	const tooltipMouseLeaveDelay = 0;

	const handleAssociatePress = async () => {
		const nextAssociated = !isAssociated;
		if (!nextAssociated) {
			onVisiblePlotsChange(fieldId, false);
		}
		await onAssociateChange(fieldId, nextAssociated);
	};

	const handleVisibilityPress = () => {
		const nextVisible = !isVisible;
		onVisiblePlotsChange(fieldId, nextVisible);
	};

	const associationColorClass = isAssociated
		? existingAssociation
			? styles.isAssociatedExisting
			: styles.isAssociatedPending
		: "";

	return (
		<div className={styles.fieldActionsGrid}>
			<div className={styles.fieldActionSlot}>
				<Tooltip
					overlay={isAssociated ? "Remove association" : "Associate field"}
					placement="top"
					mouseEnterDelay={tooltipMouseEnterDelay}
					mouseLeaveDelay={tooltipMouseLeaveDelay}
					destroyTooltipOnHide
				>
					<span className={styles.tooltipContent}>
						<Button
							icon
							basic
							className={`${styles.fieldActionBtn} ${associationColorClass}`}
							aria-label={isAssociated ? "Associated to data layer" : "Associate field to data layer"}
							aria-pressed={isAssociated}
							onClick={() => void handleAssociatePress()}
						>
							{/* @ts-expect-error -- "checkmark-square-outline" is a valid SUI icon but not in the type defs */}
							<Icon name={isAssociated ? "checkmark-square-outline" : "plus"} size="large" />
						</Button>
					</span>
				</Tooltip>
			</div>
			<div className={styles.fieldActionSlot}>
				<Tooltip
					overlay={isVisible ? "Hide on map" : "Show on map"}
					placement="top"
					mouseEnterDelay={tooltipMouseEnterDelay}
					mouseLeaveDelay={tooltipMouseLeaveDelay}
					destroyTooltipOnHide
				>
					<span className={styles.tooltipContent}>
						<Button
							icon
							basic
							className={styles.fieldActionBtn}
							aria-label={isVisible ? "Hide field plots on map" : "Show field plots on map"}
							aria-pressed={isVisible}
							onClick={handleVisibilityPress}
						>
							<Icon name="eye" className={isVisible ? "" : "closed"} size="large" />
						</Button>
					</span>
				</Tooltip>
			</div>
		</div>
	);
};

export default FieldActions;
export { FieldActionsProps };
